import type { HTTPService } from "@soft-db/http";
import type { BatchRecipientsUpdate, Recipients } from "./recipients";

export type CreateReport = {
	title: string;
	description: string;
};

export type UpdateReport = {
	enabled: boolean;
	recipients: BatchRecipientsUpdate;
} & CreateReport;

export type Report = {
	id: string;
	spaceId: string;
	distId: string;
	// TODO: Remove after api update
	orgId: string;
	recipients: Recipients;
	isSubscribed: boolean;
} & Omit<UpdateReport, "recipients">;

export type ReportSummary = Omit<Report, "recipients">;

export class ReportApi {
	constructor(private _http: HTTPService) {}

	async fetch(id: string) {
		return await this._http.get<Report>(`reports/${id}`);
	}

	async fetchDist(id: string) {
		return await this._http.get<ReportSummary[]>(`distributors/${id}/reports`);
	}

	async fetchSpace(id: string) {
		return await this._http.get<ReportSummary[]>(`spaces/${id}/reports`);
	}

	async createWithDist(id: string, report: CreateReport) {
		return await this._http.post<Report>(`distributors/${id}/reports`, report);
	}

	async createWithSpace(id: string, report: CreateReport) {
		return await this._http.post<Report>(`spaces/${id}/reports`, report);
	}

	async update(id: string, report: UpdateReport) {
		return await this._http.patch<Report>(`reports/${id}`, report);
	}

	async delete(id: string) {
		return await this._http.delete<Report>(`reports/${id}`);
	}
}
